import { render, staticRenderFns } from "./UTC.vue?vue&type=template&id=7d433d68&"
import script from "./UTC.vue?vue&type=script&lang=js&"
export * from "./UTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports